export const EllipsisComponent = {
  bindings: {
    content: '<',
    rawContent: '<'
  },
  template: `<div class="ellipsis" title="{{ $ctrl.rawContent || $ctrl.content }}" ng-if="$ctrl.content"
                  ng-bind-html="$ctrl.content"></div>`
};
